import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Reservation from "@/components/Reservation";
import InfoSection from "@/components/InfoSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#FDF6EC]" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <MenuSection />
      <Gallery />
      <Reservation />
      <InfoSection />
      <Footer />
    </div>
  );
}
